import { Box, Button, FormControl, Grid, MenuItem, Select, TextField, Tooltip} from '@mui/material';
import { makeStyles } from '@mui/styles';

import React, { forwardRef, useState } from 'react';

import { Close, Delete, GetApp } from '@mui/icons-material';

import axios from '../../../../../common/AxiosConfig';

import { useContext } from 'react';

import { AppContext } from '../../../../../../RoutesWithAuth';

import { useEffect } from 'react';

import { RESPONSE_ACTION_MAPPING } from '../../applications/constants';

import { useImperativeHandle } from 'react';

import { standardButtonStyle, cancelButtonStyle } from '../../buttonStyles';

const useStyles = makeStyles(() => ({

    "attachmentsWrapper": {
        '& label': {
            fontWeight: "bold"
        },
        marginLeft: '15px',
        marginRight: '15px',
        marginBottom: '15px',
        boxShadow: 'rgba(0, 0, 0, 0.08) 0rem 0rem 0.25rem inset',
        '& .header': {
            background: 'linear-gradient(135deg, #1e3a5f 0%, #267db7 125%, #3b9edd 100%)',
            padding: '8px 14px',
            color: "white",
            fontWeight: 600,
            fontSize: '0.85rem',
            letterSpacing: '0.4px',
            borderRadius: '8px 8px 0 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
        },
        '& input[type="file"]::file-selector-button': {

            height: '35px',
            marginTop: '-9px',
            marginLeft: '-9px',
        },
        '& .MuiInputBase-root': {
            height: '35px'
        },
        '& .isRowDeleted-row-cust-cls td': {
            color: 'red',
            textDecoration: "line-through"
        },
        '& .isRowAdded-row-cust-cls td': {
            color: 'green',
        }
    },
    tableWrapper: {
        overflow: 'auto',
        border: '1px solid #e2e8f0',
        borderRadius: '0 0 8px 8px',
        '& table': {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: '0.85rem',
        },
        '& thead': {
            background: '#778899',
            position: 'sticky',
            top: 0,
            zIndex: 10,
        },
        '& th': {
            padding: '10px 14px',
            textAlign: 'left',
            color: '#fff',
            fontWeight: 600,
            fontSize: '0.8rem',
            borderRight: '1px solid rgba(255,255,255,0.1)',
            letterSpacing: '0.3px',
            position: 'sticky',
            top: 0,
            background: '#778899',
            userSelect: 'none',
            zIndex: 9,
            '&:last-child': {
                borderRight: 'none',
            },
        },
        '& tbody tr': {
            background: '#fff',
            borderBottom: '1px solid #edf2f7',
            transition: 'background-color 0.2s ease',
            '&:nth-of-type(odd)': {
                background: '#f8fafc',
            },
            '&:hover': {
                background: '#f0f7ff',
            },
        },
        '& td': {
            padding: '8px 14px',
            borderRight: '1px solid #edf2f7',
            color: '#334155',
            fontSize: '0.82rem',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            '&:last-child': {
                borderRight: 'none',
            },
        },
    },
    attachmentUploadWrapper: {
        marginTop: '10px',
        '& input#file_upload::file-selector-button': {
            display: 'none'
        }
    },
    headerCloseBtn: {
        color: 'white',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        padding: '2px',
        display: 'flex',
        alignItems: 'center',
        borderRadius: '50%',
        '&:hover': {
            background: 'rgba(255,255,255,0.2)',
        },
    }
}));


const Attachments = ({
    attachments,
    setDisplayAttachments,
    displayAttachments,
    setLoading,
    editEnabled = false,
    responseData,
    tabInfo,
    setDisplayErrMsg,
    handleAttachmentSuccess,
    handleAttachmentsReset
},ref) => {
    const classes = useStyles();
    const context = useContext(AppContext)
    const authToken = context.authToken.get
    const userId = context.userId.get
    const setReloadHealth = context.reloadHealth.set;

    const [data, setData] = useState(attachments);
    const [attachmentType, setAttachmentType] = useState("attachment");

    useEffect(() => {
        setData(attachments);
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[JSON.stringify(attachments)])
    const handleFormClear = () => {
        setData(attachments);
        handleAttachmentsReset();
    }
    const handleFormSubmit = (edit_json, editEnabled) => {
        let responseAction = "response_action_edit" in responseData ? responseData.response_action_edit : responseData.response_action;

        if(!responseAction || !Object.keys(RESPONSE_ACTION_MAPPING).includes(responseAction) ){
            setDisplayErrMsg("Response Action cannot be blank");
            return;
        }
        setLoading(true);
        const newFiles = [];
        const deleteFiles = [];
        data.forEach((file) => {
            if (file.isNewRecord) {
                newFiles.push({
                    attachmentType: file.attachment_type,
                    fileName: file.filename
                });
            } else if (file.isDeleted) {
                deleteFiles.push(file);
            }
        })
        Promise.all(deleteFiles.map((dFile) => {
            return deleteAttachment(dFile);
        }))
        let json_reponse = responseData.response_json;
        json_reponse = JSON.stringify(json_reponse, null, 2) !== '' ? JSON.stringify(json_reponse, null, 2) : '{}'
        if(editEnabled){
            json_reponse = edit_json !== '' ? edit_json : '{}'
        }
        axios.post('ticket/update_response', {
            dsar_id: tabInfo.dsarRequestId,
            app_id: tabInfo.app_id,
            creator_id: userId,
            response_json: json_reponse,
            response_action: responseAction,
            fileNames: newFiles,
            expectedAttachments: "expected_attachments_count_edit" in responseData ? responseData.expected_attachments_count_edit : responseData.expected_attachments
        }, {
            headers: {
                Authorization: authToken
            }
        }).then(async res => {
            const posts = res.data.presignedPosts

            // Trigger Health Status to update the Calender ad=nd Error Icon
            setReloadHealth(Math.round(Math.random() * 1e5));

            for (const post of posts) {
                // For the case where there are multiple files, find the proper file from the array
                const filename = post.fields.key.split('/').pop()

                // Populate the form data
                const formData = new FormData()
                for (const key in post.fields) {
                    formData.append(key, post.fields[key])
                }

                // Iterate through all the files and file one with the matching filename
                for (const file of data) {
                    if (file.filename === filename) {
                        formData.append('file', file.fileObject);
                    }
                }

                await new Promise((resolve, reject) => {
                    axios.post(post.url, formData, {
                        headers: { 'Content-Type': 'multipart/form-data' }
                    }).then(res => {
                        resolve(res)
                    }).catch(err => {
                        reject(err)
                    })
                })
            }
            handleAttachmentSuccess();
            setLoading(false);

        }).catch(err => {
            if (err?.response?.status === 400) {
                setDisplayErrMsg(err?.response?.data?.message || "Invalid JSON format in downstream response");
            }
            setLoading(false);
        })
    }

    useImperativeHandle(ref,()=>{
        return {
            clearAttachments : handleFormClear,
            submitAttachments : handleFormSubmit   
        }
    },)

    const deleteAttachment = ({ filename, appId, dsarRequestId }) => {

        return new Promise((resolve, reject) => {
            axios.delete('response/attachments', {
                headers: { Authorization: authToken },
                data: { s3_key: `${dsarRequestId}/${appId}/${filename}` }
            }).then(res => {
                resolve(res)
            }).catch(err => {
                reject(err)
            })
        })
    }

    const downloadFile = ({ filename, appId, dsarRequestId }) => {
        setLoading(true);
        axios.get(`ticket/response/download/${dsarRequestId}/${appId}/${filename}`, {
            headers: {
                Authorization: authToken
            }
        }).then(res => {
            setLoading(false);
            const link = document.createElement('a');
            link.href = res.data.presignedGet;
            link.setAttribute('download', `${filename}`);
            document.body.appendChild(link);
            link.click();
            link.remove()

        }).catch(() => {
            setLoading(false);
        })
    }
    const getGridData = () => {
        let sortedAttachments = data?.sort((a, b) => a.attachment_type.localeCompare(b.attachment_type) || a.filename.localeCompare(b.filename)) || [];
        return sortedAttachments.map((attachment, index) => {
            return {
                ...attachment,
                id: index + 1,
            }
        });
    }
    if(!displayAttachments){
        return (<>
        </>)
    }
    return (
        <>
            <div data-testid={"attachmentsWrapper"} className={classes.attachmentsWrapper}>
                <div className={"header"}>
                    <span>Attachments</span>
                    <button
                        className={classes.headerCloseBtn}
                        aria-label="close"
                        onClick={(e) => {
                            e.stopPropagation();
                            setDisplayAttachments(false);
                        }}
                    >
                        <Close fontSize="small" />
                    </button>
                </div>
                <Box padding={"10px"}>
                    <div className={classes.tableWrapper}>
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: 50, textAlign: 'center' }}>#</th>
                                    <th style={{ minWidth: 200 }}>File Name</th>
                                    <th style={{ width: 120 }}>Type</th>
                                    <th style={{ width: 120, textAlign: 'center' }}>Download</th>
                                    <th style={{ width: 120, textAlign: 'center' }}>Delete</th>
                                </tr>
                            </thead>
                            <tbody>
                                {getGridData().map((row, index) => {
                                    const rowClasses = [];
                                    if (row.isDeleted) rowClasses.push('isRowDeleted-row-cust-cls');
                                    else if (row.isNewRecord) rowClasses.push('isRowAdded-row-cust-cls');
                                    return (
                                        <tr key={row.id || index} className={rowClasses.join(' ')}>
                                            <td style={{ textAlign: 'center' }}>{row.id}</td>
                                            <td title={row.filename}>{row.filename}</td>
                                            <td>{row.attachment_type}</td>
                                            <td style={{ textAlign: 'center' }}>
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    startIcon={<GetApp />}
                                                    disabled={row.isNewRecord || row.isDeleted}
                                                    data-testid={"download"}
                                                    onClick={() => { downloadFile(row) }}
                                                    sx={{
                                                        ...standardButtonStyle,
                                                        padding: '3px 14px',
                                                        fontSize: '0.7rem',
                                                    }}
                                                >
                                                    Download
                                                </Button>
                                            </td>
                                            <td style={{ textAlign: 'center' }}>
                                                <Button
                                                    variant="contained"
                                                    size="small"
                                                    startIcon={<Delete />}
                                                    disabled={!editEnabled || row.isDeleted}
                                                    data-testid={"delete"}
                                                    onClick={() => {
                                                        const newData = [];
                                                        data.forEach((attachments) => {
                                                            if (row.filename === attachments.filename) {
                                                                if (!attachments.isNewRecord) {
                                                                    newData.push({
                                                                        ...attachments,
                                                                        isDeleted: true,
                                                                    });
                                                                }
                                                            } else {
                                                                newData.push(attachments);
                                                            }
                                                        });
                                                        setData(newData);
                                                    }}
                                                    sx={{
                                                        ...cancelButtonStyle,
                                                        padding: '3px 14px',
                                                        fontSize: '0.7rem',
                                                    }}
                                                >
                                                    Delete
                                                </Button>
                                            </td>
                                        </tr>
                                    );
                                })}
                                {getGridData().length === 0 && (
                                    <tr>
                                        <td colSpan={5} style={{ textAlign: 'center', padding: '20px', color: '#64748b' }}>
                                            No rows
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Box>

                <div className={classes.attachmentUploadWrapper}>
                    <Grid container>
                        <Grid item xs={6}>
                            <div className="form-group col">
                                <label htmlFor={"file_upload"} className="ml-1">{"Upload File"}</label>
                                <Box display={"flex"}>
                                    <Button
                                        style={{ marginRight: "10px" }}
                                        variant="contained"
                                        color="primary"
                                        component="span"
                                        disabled={!editEnabled}
                                        onClick={() => {
                                            document.getElementById("file_upload").click();
                                        }}
                                    >
                                        Choose Files
                                    </Button>
                                    <TextField
                                        style={{ flex: 1 }}
                                        size={"small"}
                                        type={"file"}
                                        fullWidth
                                        disabled={!editEnabled}
                                        id={"file_upload"}
                                        label=""
                                        variant="outlined"
                                        onChange={(ev) => {
                                            if (ev.target?.files?.length > 0) {
                                                const newFiles = [];
                                                const duplicateFileNames = [];
                                                const allFiles = ev.target?.files;
                                                for (let i = 0; i < allFiles.length; i++) {
                                                    if (data.findIndex((file) => file.filename === allFiles[i].name) === -1) {
                                                        newFiles.push({
                                                            fileObject: allFiles[i],
                                                            isNewRecord: true,
                                                            id: (data.length + 1 + i),
                                                            filename: allFiles[i].name,
                                                            attachment_type: attachmentType
                                                        });
                                                    } else {
                                                        duplicateFileNames.push(allFiles[i].name);
                                                    }
                                                }
                                                setData([
                                                    ...data,
                                                    ...newFiles
                                                ]);
                                                if (duplicateFileNames.length > 0) {
                                                    setDisplayErrMsg(`A file with same name ${duplicateFileNames.join(",")} already exists!`);
                                                }
                                                setTimeout(() => {
                                                    document.getElementById("file_upload").value = "";
                                                }, 500);
                                            }
                                        }}
                                        inputProps={{
                                            accept: attachmentType === "Screenshot" ? "image/*" : ".pdf, .csv, .zip",
                                            required: true,
                                            multiple: true
                                        }}
                                    />
                                </Box>
                            </div>
                        </Grid>
                        <Grid item xs={3}>
                            <div className="form-group col">
                                <label htmlFor={"fileType"} className="ml-1">{"Response File Type"}</label>
                                <FormControl fullWidth variant="outlined" >
                                    <Select
                                        size={"small"}
                                        id={"fileType"}
                                        multiple={false}
                                        disabled={!editEnabled}
                                        value={attachmentType}
                                        onChange={(e) => {
                                            setAttachmentType(e.target.value);
                                        }}
                                        renderValue={(selected) => selected}
                                        MenuProps={{
                                            PaperProps: {
                                                sx: {
                                                    '& .MuiMenuItem-root': {
                                                        fontSize: '0.85rem',
                                                        padding: '10px 16px',
                                                    },
                                                },
                                            },
                                        }}
                                    >
                                        {["Attachment", "Screenshot"].map((name) => (
                                            <MenuItem key={name} className={`${classes.menuitemmultiselect}`} value={name}>
                                                {name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </>
    )
}
export default React.memo(forwardRef(Attachments));

